import React, { useState } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import ReusableInput from "components/Inputs/ReusableInput";
import GradientButton from "components/Buttons/GradientButton";

const AllocateDriverPlanDrawer = ({
    isOpen,
    onClose,
    driver,
    onAllocate,
}) => {
    const [formData, setFormData] = useState({
        deliveries: 20,
        expiry_days: 30,
        notes:
            "Complimentary delivery allocation awarded by Mogoma management.",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = () => {
        onAllocate({
            driver_id: driver?.driver?.driver_id,
            deliveries: Number(formData.deliveries),
            expiry_days: Number(formData.expiry_days),
            notes: formData.notes,
        });

        onClose();
    };

    return (
        <ReusableDrawer
            isOpen={isOpen}
            onClose={onClose}
            headerContent={<h2>Allocate Free Deliveries</h2>}
            bodyContent={
                <Stack spacing={4}>
                    <ReusableInput
                        label="Deliveries"
                        name="deliveries"
                        value={formData.deliveries}
                        onChange={handleChange}
                        type="number"
                    />

                    <ReusableInput
                        label="Expiry Days"
                        name="expiry_days"
                        value={formData.expiry_days}
                        onChange={handleChange}
                        type="number"
                    />

                    <ReusableInput
                        label="Notes"
                        name="notes"
                        value={formData.notes}
                        onChange={handleChange}
                        type="textarea"
                    />
                </Stack>
            }
            footerContent={
                <Stack direction="row">
                    <GradientButton onClick={onClose} height="37px" fontSize="13px">
                        Cancel
                    </GradientButton>

                    <GradientButton onClick={handleSubmit} height="37px" fontSize="13px">
                        Allocate
                    </GradientButton>
                </Stack>
            }
        />
    );
};

export default AllocateDriverPlanDrawer;